// extracted by mini-css-extract-plugin
export default {"container":"Search_container__BSbg1","search":"Search_search__4e1YI"};